import React, { useRef } from "react";
import {
  Box,
  Card,
  CardMedia,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import MUITypography from "../../Components/MUITypography";
import { landing_venueData } from "../../Util/ConstnatUtils";

const EventVenueTypes = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (!scrollRef.current) return;
    const scrollAmount = isMobile ? 280 : 420;

    scrollRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        maxWidth: 1280,
        mx: "auto",
        px: { xs: 2, md: 3 },
        py: { xs: 6, md: 10 },
      }}
    >
      {/* Header */}
      <Box textAlign="center" mb={{ xs: 4, md: 6 }}>
        <MUITypography
          variant="h2"
          fontWeight={700}
          sx={{
            fontSize: { xs: 22, sm: 26, md: 34 },
            mb: 2,
          }}
        >
          One CRM for All Event Venue Types
        </MUITypography>

        <Box display="flex" justifyContent="center" gap={1}>
          <Box
            sx={{
              width: 96,
              height: 5,
              borderRadius: 3,
              bgcolor: theme.palette.primary.main,
            }}
          />
          <Box
            sx={{
              width: 48,
              height: 5,
              borderRadius: 3,
              bgcolor: theme.palette.secondary.main,
            }}
          />
        </Box>
      </Box>

      {/* Scroll Container */}
      <Box sx={{ position: "relative" }}>
        <Box
          ref={scrollRef}
          sx={{
            display: "flex",
            gap: { xs: 2, sm: 3 },
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            pb: 1,
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {landing_venueData.map((venue, index) => (
            <Card
              key={venue.id}
              sx={{
                flex: "0 0 auto",
                width: {
                  xs: "85%",
                  sm: 320,
                  md: 380,
                },
                scrollSnapAlign: "start",
                borderRadius: 4,
                overflow: "hidden",
                boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 18px 40px rgba(0,0,0,0.12)",
                },
              }}
            >
              <CardMedia
                component="img"
                height="190"
                image={venue.image}
                alt={venue.title}
                sx={{ objectFit: "cover" }}
              />

              <Box sx={{ p: 3 }}>
                <MUITypography
                  variant="h3"
                  sx={{
                    fontWeight: 700,
                    fontSize: 42,
                    lineHeight: 1,
                    color: theme.palette.primary.main,
                    mb: 1,
                  }}
                >
                  {String(index + 1).padStart(2, "0")}
                </MUITypography>

                <MUITypography
                  variant="h6"
                  fontWeight={600}
                  mb={1}
                >
                  {venue.title}
                </MUITypography>

                <MUITypography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    lineHeight: 1.7,
                  }}
                >
                  {venue.description}
                </MUITypography>
              </Box>
            </Card>
          ))}
        </Box>

        {/* Navigation Arrows (Desktop only) */}
        {!isMobile && (
          <>
            <IconButton
              onClick={() => scroll("left")}
              sx={{
                position: "absolute",
                top: "45%",
                left: -22,
                bgcolor: "#fff",
                boxShadow: 3,
                "&:hover": {
                  bgcolor: theme.palette.primary.main,
                  color: "#fff",
                },
              }}
            >
              <ChevronLeft />
            </IconButton>

            <IconButton
              onClick={() => scroll("right")}
              sx={{
                position: "absolute",
                top: "45%",
                right: -22,
                bgcolor: "#fff",
                boxShadow: 3,
                "&:hover": {
                  bgcolor: theme.palette.primary.main,
                  color: "#fff",
                },
              }}
            >
              <ChevronRight />
            </IconButton>
          </>
        )}
      </Box>
    </Box>
  );
};

export default EventVenueTypes;
